// extracted by mini-css-extract-plugin
export default {"image":"ModalCarpark_image__q9nR0","modal":"ModalCarpark_modal__mDHOx","temprature":"ModalCarpark_temprature__hoGGF"};